import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "./api";
import { parseJWT } from "./utils/jwtUtils";

import BetAmountPage from "./pages/BetAmountPage";
import SelectCardsPage from "./pages/SelectCardsPage";
import ConfirmCardPage from "./pages/ConfirmCardPage";
import BetHistory from "./pages/BetHistory";
import BingoGame from "./pages/BingoGame";
import HowToPlay from "./pages/HowToPlay";
import ReferralIncome from "./pages/ReferralIncome";
import WalletPage from "./pages/WalletPage";
import ProfilePage from "./pages/ProfilePage";
import UpdateProfile from "./pages/UpdateProfile";
import Invoice from "./pages/Invoicer";

import AdminDashboard from "./pages/AdminDashboard/AdminDashboard";
import UpdateUser from "./pages/AdminDashboard/UpdateUser";

import LoadingPage from "./pages/LoadingPage";
import AdminRoute from "./components/AdminRoute"; // ✅ added

function App() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const authenticate = async () => {
      try {
        const stored = localStorage.getItem("userInfo");

        // ✅ If already logged in
        if (stored) {
          try {
            const parsed = JSON.parse(stored);
            const userInfo = parseJWT(parsed.token);

            // token invalid or expired
            if (!userInfo) {
              localStorage.removeItem("userInfo");
            } else {
              // only redirect on first app load (home route)
              if (location.pathname === "/") {
                if (
                  userInfo.role === "admin" ||
                  userInfo.role === "super_admin"
                ) {
                  navigate("/admin-page", { replace: true });
                }
              }

              setLoading(false);
              return;
            }
          } catch (err) {
            console.error("Stored token parse error:", err);
            localStorage.removeItem("userInfo");
          }
        }

        // ✅ Telegram Mini App auth
        const tg = window.Telegram?.WebApp;

        if (!tg?.initData) {
          setError("Please open this app inside Telegram.");
          setLoading(false);
          return;
        }

        tg.ready();
        tg.expand();

        const res = await api.post("/telegram-auth", {
          initData: tg.initData,
        });

        const token = res.data.token;
        const userInfo = parseJWT(token);

        // invalid token returned
        if (!userInfo) {
          setError("Invalid authentication token.");
          setLoading(false);
          return;
        }

        // save login
        localStorage.setItem(
          "userInfo",
          JSON.stringify({
            token,
            user: userInfo,
          }),
        );

        // role-based redirect after fresh login
        if (userInfo.role === "admin" || userInfo.role === "super_admin") {
          navigate("/admin-page", { replace: true });
        } else {
          navigate("/", { replace: true });
        }

        setLoading(false);
      } catch (err) {
        console.error("Authentication error:", err);

        setError(err.response?.data?.message || "Authentication failed");

        setLoading(false);
      }
    };

    authenticate();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h3>{error}</h3>
      </div>
    );
  }

  return (
    <Routes>
      {/* USER ROUTES */}
      <Route path="/" element={<BetAmountPage />} />
      <Route path="/select-cards" element={<SelectCardsPage />} />
      <Route path="/confirm/:id" element={<ConfirmCardPage />} />
      <Route path="/play" element={<BingoGame />} />
      <Route path="/history" element={<BetHistory />} />
      <Route path="/wallet" element={<WalletPage />} />
      <Route path="/HowToPlay" element={<HowToPlay />} />
      <Route path="/referralIncome" element={<ReferralIncome />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/profile-update" element={<UpdateProfile />} />
      <Route path="/invoice" element={<Invoice />} />

      {/* 🔒 ADMIN PROTECTED ROUTES */}
      <Route
        path="/admin-page"
        element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        }
      />

      <Route
        path="/users/:id"
        element={
          <AdminRoute>
            <UpdateUser />
          </AdminRoute>
        }
      />
    </Routes>
  );
}

export default App;
